import { render } from "./TableListColumn.vue?vue&type=template&id=6824d156&scoped=true"
import script from "./TableListColumn.vue?vue&type=script&lang=js"
export * from "./TableListColumn.vue?vue&type=script&lang=js"

import "./TableListColumn.vue?vue&type=style&index=0&id=6824d156&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6824d156"]])

export default __exports__